<style scoped lang="scss">
    .file-dropzone {
        border: none;
        text-align: center;
    }
    .vue-dropzone {
        background: #eee;
        border: thin dashed #666;
        padding: 0;
        margin: 0;
        min-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        .dropzone-custom-title {
            margin: 0;
        }
    }
    .file-wrapper {
        display: flex;
        align-items: center;
    }
    .file-name {
        display: block;
        min-width: 300px;
    }
</style>

<template>
    <div class="uk-grid">
        <div class="uk-width-1-1 ">
            <legend>Last Year's Form 1040 for {{ label }}</legend>
        </div>

        <div class="uk-width-small-1-1 uk-width-medium-1-2 uk-width-large-1-3">
            <label>Adjusted Gross Income</label>
            <validated-section :errors="errors" field="income_amount">
                <vue-numeric currency="$" v-model="income.income_amount" @change.native="onInputChanged" type="text" required class="uk-form-large uk-input uk-width-1-1"/>
            </validated-section>
        </div>

        <div class="uk-width-1-1 uk-margin-large-top">
            <h3>{{ __('tenant.inc_upload_1040', {year: application.tax_year}) }}</h3>
            <p>Download Your Copy of the 1040 Form <a href="https://www.irs.gov/pub/irs-pdf/f1040.pdf" target="_blank">Here</a></p>
            <validated-section :errors="errors" field="document">
                <div>
                    <vue-dropzone
                        ref="dropzoneUpload"
                        :options="dropzoneOptions"
                        :useCustomSlot=true
                        v-on:vdropzone-sending="sendingFile"
                        v-on:vdropzone-max-files-exceeded="onMaxFilesExceeded"
                        v-on:vdropzone-success="onFileUpdated"
                    >
                      <div class="dropzone-custom-content file-dropzone">
                        <p class="dropzone-custom-title">Drop File Here or Click to Select a File!</p>
                      </div>
                    </vue-dropzone>
                </div>
            </validated-section>
        </div>

        <div class="uk-width-1-1 uk-margin-large-top" v-if="income.documents.length">
            <div v-for="(document, index) in income.documents" class="uk-margin-bottom file-wrapper">
                <div class="icon-container">
                    <a href="javascript:;" @click="previewFile(document)" class="custom-link">
                        <i class="uk-icon-medium a-file-search"></i><br>
                        <span style="font-size: 0.8em;">PREVIEW</span>
                    </a>
                </div>
                <a :href="`documents/download/${document.id}`" target="_blank" class="file-name custom-link"><span class="uk-margin-left">{{document.filename}}</span></a>
                <a href="javascript:;" class="uk-button uk-button-danger uk-margin-left" @click="deleteDocument(index, document)"><i class="a-trash-2"></i></a>
            </div>
        </div>


        <div class="uk-width-1-1 uk-margin-large-top">
            <h3 id="other_members_using_1040">Are there any other household members filed in this 1040?</h3>

            <div class="uk-margin-bottom">
                <label for="1040-other-members-yes" style="margin-right: 50px;">
                    <input name="1040-other-members-yes" type="radio" :value="1" v-model="income.has_other_members" aria-labelledby="other_members_using_1040">
                    &nbsp; Yes
                </label>
                <label for="1040-other-members-no">
                    <input name="1040-other-members-no" type="radio" :value="0" v-model="income.has_other_members" aria-labelledby="other_members_using_1040">
                    &nbsp; No
                </label>
            </div>
        </div>

        <div class="uk-width-1-1 uk-margin-large-bottom" v-if="income.has_other_members">
            <div v-for="hhMember in members" v-if="member.id !== hhMember.id">
                <label :for="'other-member-'+member.id" >
                    <input :name="'other-member-'+hhMember.id" type="checkbox" :value="hhMember.id" @change="onOtherMemberChange" v-model="income.other_members"> &nbsp;
                    {{ hhMember.first_name }} {{ hhMember.last_name }}
                </label>
            </div>
        </div>
        <preview-document-modal ref="previewModal"></preview-document-modal>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    // import moment from 'moment';
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import ValidatedSection from "../../../components/Common/ValidatedSection";
    import PreviewDocumentModal from "../../../../dashboard/pages/Documents/PreviewDocumentModal";

    export default {
        name: "Irs1040EntryForm",
        props: ['label', 'member', 'values', 'members', 'url'],
        components: {
            vueDropzone: vue2Dropzone,
            ValidatedSection,
            PreviewDocumentModal,
        },
        computed: {
            ...mapState('Application', {
                application: 'application',
            }),
        },
        data() {
            return {
                errors: {
                },
                lastYear: moment().subtract(1, 'year').format('YYYY'),
                file: null,
                dropzoneOptions: {
                    url: this.url,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    maxFiles: 1,
                    acceptedFiles: ['.pdf', '.png', '.jpg', '.jpeg'].join(','),
                },
                income: {
                    id: null,
                    type: '1040',
                    income_amount: 0,
                    documents: [],
                    has_other_members: false,
                    other_members: []
                }
            }
        },
        mounted() {
            if (this.member.incomes && this.member.incomes.length)
            {
                const filteredIncome = this.member.incomes.find(item => item.type === '1040')
                if (filteredIncome)
                {
                    this.income = filteredIncome
                    this.onOtherMemberChange();
                }
            }
        },
        methods: {
            previewFile(document) {
                let url =`/api/hope/documents/${document.id}/preview`;
                this.$refs.previewModal.open(url, document);
            },

            onOtherMemberChange() {
                this.$emit('includedMembersChanged', {fromMember: this.member.id, memberIds: this.income.other_members});
            },

            sendingFile(file, xhr, formData) {
                formData.append('application_id', this.application.id);
                formData.append('household_member_id', this.member.id);
                formData.append('type', this.income.type);
            },

            onMaxFilesExceeded(file) {
                this.$refs.dropzoneUpload.removeAllFiles();
                this.$refs.dropzoneUpload.manuallyAddFile(file);
            },

            _getDocumentIdsFromOrgFiles(files) {
                if (files && files.length)
                {
                    const res = JSON.parse(files[0].xhr.response);
                    return [res.document]
                }
                return []
            },

            getDocuments() {
                const orgFiles = this.$refs.dropzoneUpload.getAcceptedFiles()
                return this._getDocumentIdsFromOrgFiles(orgFiles);
            },

            onFileUpdated() {
                const newDocs = this.getDocuments();
                if (newDocs && newDocs.length)
                    this.income.documents.push(newDocs[0]);

                this.$refs.dropzoneUpload.removeAllFiles();
            },

            deleteDocument(index, doc) {
                this.$store
                    .dispatch('Document/deleteDocument', doc.id)
                    .then((res) => {
                        this.income.documents.splice(index, 1);
                    })
                    .catch((err) => {
                    })
            },

            validate() {
                this.errors = {};
                let isValid = true;
                if (!this.income.income_amount)
                {
                    this.errors['income_amount'] = { errors: [ "Please input a value." ]}
                    isValid = false;
                }
                if (!this.income.documents.length)
                {
                    this.errors['document'] = { errors: [ "You must provide a document." ]}
                    isValid = false;
                }

                return isValid;
            },

            onInputChanged() {
                this.$emit('updated', {member: this.member, amounts: [this.income]});
            }
        }
    }
</script>
